// Dev-host convenience: when the backend URL is configured for localhost but the
// app was opened from a *different* host — e.g. 127.0.0.1 or a phone/tablet on
// the LAN — rewrite the URL to that same host. Besides reaching the right dev
// machine, this keeps host-only refresh cookies valid across Dev Console login.
//
// No-op for real localhost (dev machine) and for production (api.airbotix.ai is
// not a localhost URL, so it's never rewritten).

export function sameHostForDevPage(configuredUrl: string, pageHostname: string): string {
  try {
    const url = new URL(configuredUrl);
    const page = pageHostname;
    const localApi = url.hostname === 'localhost' || url.hostname === '127.0.0.1';
    if (localApi && page && page !== url.hostname) {
      url.hostname = page;
      // strip the trailing slash URL() adds for an origin-only URL; keep any path
      return url.toString().replace(/\/$/, '');
    }
  } catch {
    // malformed URL — fall back to the configured value
  }
  return configuredUrl;
}

export function sameHostInDev(configuredUrl: string): string {
  if (typeof window === 'undefined') return configuredUrl;
  return sameHostForDevPage(configuredUrl, window.location.hostname);
}
